import { Box, Menu, Typography } from '@mui/material'
import NotificationItemCard from './NotificationItemCard'
import { CBox, RBox } from '@/pages/__styled'
import { RoundedOutlineButton } from '@/components/StyledComponents'
import { useNavigate } from 'react-router-dom'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'
import { useMemo } from 'react'
import { ActivityTypeUtil, NotificationItem } from '@/types/notification'
import RequestListItem from './RequestListItem'
import { ConnectionRequest } from '@/types'
import { groupedNotifications } from '@/utils/helper'

interface NotificationMenuProps {
  anchor: null | HTMLElement
  open: boolean
  onClose: () => void
}
const NotificationMenu = ({ anchor, open, onClose }: NotificationMenuProps) => {
  const navigate = useNavigate()
  const { markAsRead } = useAppStore()
  const [notificationItems] = useAppStore((state) => [state.notification.items], shallow)
  const [connRequests] = useAppStore((state) => [state.user.connRequests], shallow)

  const hasData = notificationItems.length > 0 || connRequests.length > 0

  const notificationGroups = useMemo(() => {
    return notificationItems.length > 0 ? groupedNotifications(notificationItems) : []
  }, [notificationItems])

  const onClickViewAll = () => {
    onClose()
    navigate('/notification')
  }

  const showViewAllButton = useMemo(() => {
    return notificationItems.length > 0
  }, [notificationItems])

  const onClickNotificationItem = (item: NotificationItem) => {
    onClose()

    if (ActivityTypeUtil.isTopicRelatedEvent(item.eventType)) {
      let previewQuery = new URLSearchParams()
      previewQuery.set('topicID', ActivityTypeUtil.getTopicID(item))
      previewQuery.set('topicType', item.topicType.toString())
      if (ActivityTypeUtil.isNoteLevelEvent(item.eventType)) {
        previewQuery.set('noteID', ActivityTypeUtil.getNoteID(item))
      }
      navigate(`/preview?${previewQuery.toString()}`)
    } else {
      markAsRead(item.eventID)
      let previewQuery = new URLSearchParams()
      previewQuery.set('id', item.sourceUserID)
      navigate(`/profile/user?${previewQuery.toString()}`)
    }
  }

  const onClickRequestItem = (request: ConnectionRequest) => {
    onClose()
    let previewQuery = new URLSearchParams()
    previewQuery.set('id', request.requestorID)
    navigate(`/profile/user?${previewQuery.toString()}`)
  }

  return (
    <Menu
      id='menu-user'
      anchorEl={anchor}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      sx={{
        '& .MuiPaper-root': {
          width: '360px',
          padding: '20px 0px',
          marginTop: '8px',
        },
      }}
      open={open}
      onClose={onClose}
    >
      <CBox sx={{ p: '0px 25px', gap: '20px' }}>
        <Typography style={{ fontSize: 18, fontWeight: '600' }}>{'Notifications'}</Typography>

        {!hasData && (
          <RBox sx={{ justifyContent: 'center', alignItems: 'center' }}>
            <Typography style={{ fontSize: 13, fontWeight: '400' }}>{'No messages'}</Typography>
          </RBox>
        )}

        {connRequests.map((el, idx) => (
          <RequestListItem key={`${idx}`} item={el} onClick={onClickRequestItem} />
        ))}

        {notificationGroups.map((e, i) => (
          <NotificationItemCard
            key={`${i}`}
            item={e}
            onClick={onClickNotificationItem}
            hidePopMenu={onClose}
          />
        ))}
        {showViewAllButton && (
          <RoundedOutlineButton sx={{ padding: '8px' }} onClick={onClickViewAll}>
            {'View All Activities'}
          </RoundedOutlineButton>
        )}
      </CBox>
    </Menu>
  )
}

export default NotificationMenu
